import React, { useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import useFetch from '../../hooks/useFetch';
import useForm from '../../hooks/useForm';

const AssignRoleModal = ({ isOpen, onClose, onSuccess, employee }) => {
    const API_URL = process.env.REACT_APP_API_URL;
    
    // Only fetch if we have a valid employee ID
    const { data: employeeRole, refetch } = useFetch(
        employee ? `${API_URL}/roles/${employee}` : null
    );

    // Fetch all available roles
    const { data: roles } = useFetch(`${API_URL}/roles`);

    const { values, isSubmitting, handleChange, handleSubmit, setValues } = useForm({
        role_id: '',
    });

    
    // Update role_id when employeeRole is fetched
    useEffect(() => {
        if (employeeRole?.role_id) {
            setValues((prev) => ({ ...prev, role_id: employeeRole.role_id }));
        }
    }, [employeeRole, setValues]);



    const onSubmit = async (values) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.put(
                `${API_URL}/roles/${employee}`,
                values,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            onSuccess();
            refetch(); // Refresh data after successful update
            onClose();

            Swal.fire({
                title: 'Success!',
                text: response.data.message,
                icon: 'success',
                showConfirmButton: false,
                timer: 5000
            });
        } catch (error) {
            console.error('Error updating employee:', error);
            Swal.fire({
                title: 'Error!',
                text: 'There was an error updating the employee.',
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            });
        }
    };

    return (
        <div id="assign_role" className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto overflow-x-hidden max-h-full ${isOpen ? 'flex' : 'hidden'}`} data-modal-backdrop="static" tabIndex="-1" aria-hidden="true">
            <div className="relative p-4 w-full max-w-2xl max-h-full">
                <div className="relative bg-white rounded-lg shadow">
                    <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
                        <h3 className="text-xl font-semibold text-gray-900">Assign Role</h3>
                        <button
                            type="button"
                            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                            onClick={onClose}
                        >
                            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                    </div>
                    <div className="p-4 md:p-5 space-y-4">
                        <form onSubmit={(e) => handleSubmit(e, onSubmit)}>
                            <div className="w-full">
                                <label htmlFor="role_id" className="block font-medium text-gray-700 mb-2">Role</label>
                                <select
                                    id="role_id"
                                    name="role_id"
                                    value={values.role_id || ''} // Ensure selected role is displayed
                                    onChange={handleChange} 
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5"
                                >
                                    <option value="">Select a role</option> {/* Default option */}
                                    {roles?.map((role) => (
                                        <option key={role.id} value={role.id}>
                                            {role.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b">
                                <button 
                                    type="submit" 
                                    className="text-white bg-[var(--customRed)] hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                    disabled={isSubmitting} 
                                >
                                    {isSubmitting ? "Updating..." : "Update"}
                                </button>
                                <button type="button" className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-red-700 focus:z-10 focus:ring-4 focus:ring-gray-100" onClick={onClose}>Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssignRoleModal;
